export default "__VITE_ASSET__Ct48NK9Y__"